import { constant, isFunction } from 'lodash';
import { helpers } from 'veritone-redux-common';
const { fetchGraphQLApi } = helpers;
import { getConfig } from 'modules/config';
import { guid } from 'helpers/misc';
import { selectSessionToken } from 'modules/user';

export function commonHeaders(state) {
  return {
    Authorization: `Bearer ${selectSessionToken(state)}`,
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
}

export async function callGraphQLApi({
  actionTypes: [requestType, successType, failureType],
  query,
  variables,
  operationName,
  bailout = constant(false),
  meta,
  dispatch,
  getState
}) {
  if (!isFunction(dispatch) || !isFunction(getState)) {
    throw new Error('callGraphQLApi requires dispatch and getState functions');
  }

  const state = getState();
  const endpoint = getConfig(state).services.graphqlUri;
  const token = selectSessionToken(state);

  const shouldBail = bailout(state);
  if (shouldBail) {
    return;
  }

  const requestId = guid();

  dispatch({
    type: requestType,
    meta: { ...variables, operationName, query, requestId, ...meta }
  });

  let response;
  try {
    response = await fetchGraphQLApi({
      endpoint,
      query,
      variables,
      operationName,
      token
    });
  } catch (e) {
    dispatch({
      type: failureType,
      error: true,
      payload: e,
      meta: { ...variables, operationName, query, requestId, ...meta }
    });

    let error = new Error('API call failed');
    // wrap this single error for consistency with graphQL errors, which are always
    // wrapped.
    error.errors = [e];
    throw error;
  }

  if (response.errors && response.errors.length) {
    dispatch({
      type: failureType,
      error: true,
      payload: response.errors,
      meta: { ...variables, operationName, query, requestId, ...meta }
    });

    let error = new Error('API response included errors');
    error.errors = response.errors;
    throw error;
  }

  dispatch({
    type: successType,
    payload: response,
    meta: { ...variables, operationName, query, requestId, ...meta }
  });

  return response;
}



// WEBPACK FOOTER //
// ./src/client/helpers/api/index.js